import React, { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import AdminLayout from "../../../components/Admin/Layout";
import HeroBanner from "../../../components/Admin/LandingPage/HeroBanner";
import TrendingNow from "../../../components/Admin/LandingPage/TrendingNow";

const pathPrefix = "/admin/landing-pages";

const AdminLandingPagePage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname !== pathPrefix) return;
    navigate(`${pathPrefix}/hero-banners`);
  }, [location.pathname]);

  return (
    <AdminLayout
      title={"Landing Page"}
      tabs={[
        { id: 0, title: "Hero Banner", path: `${pathPrefix}/hero-banners` },
        { id: 1, title: "Trending Now", path: `${pathPrefix}/trending-nows` },
      ]}
    >
      <Routes>
        <Route path="/hero-banners" element={<HeroBanner />} />
        <Route path="/trending-nows" element={<TrendingNow />} />
      </Routes>
    </AdminLayout>
  );
};

AdminLandingPagePage.propTypes = {};

export default AdminLandingPagePage;
